import { Button, Flex } from '#atoms';
import { PATH } from '#const/path';
import useCheckOnboardingQuery from '#hooks/queries/onboard/useCheckOnboardingQuery';
import useGetCurrentStepQuery from '#hooks/queries/onboard/useGetCurrentStepQuery';
import { Modal } from '#molecules';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useOnBoardStep } from 'src/components/pages/OnBoardStep/OnBoardStep.hooks';
import styled from 'styled-components';

export default function LoadModal() {
  const [isOpenLoadModal, setIsOpenLoadModal] = useState(false);
  const { setStep } = useOnBoardStep();
  const { data: isCompletedOnboarding } = useCheckOnboardingQuery();
  const { data: currentStep } = useGetCurrentStepQuery();
  const navigate = useNavigate();

  const handleContinue = () => {
    setIsOpenLoadModal(false);
    if (currentStep) {
      setStep(currentStep);
      navigate(PATH.ONBOARD_STEP);
    }
  };

  useEffect(() => {
    if (
      isCompletedOnboarding === undefined ||
      isCompletedOnboarding === null ||
      !currentStep
    )
      return;
    if (!isCompletedOnboarding && currentStep !== 1) {
      setIsOpenLoadModal(true);
    }
  }, [isCompletedOnboarding, currentStep]);

  useEffect(() => {
    if (isCompletedOnboarding) {
      navigate(PATH.HOME);
    }
  }, [isCompletedOnboarding]);

  return (
    <>
      {isOpenLoadModal && (
        <Modal onClose={() => setIsOpenLoadModal(false)}>
          <Text>
            작성 중이던 프로필이 있어요!{'\n'}
            이어서 작성하시겠습니까?
          </Text>
          <Flex fullWidth gap={12}>
            <Button onClick={handleContinue}>이어서 작성</Button>
          </Flex>
        </Modal>
      )}
    </>
  );
}

const Text = styled.div`
  color: ${({ theme }) => theme.palette.gray15};
  font-size: 18px;
  font-weight: 500;
  white-space: pre-wrap;
  text-align: center;
`;
